module.exports = __webpack_public_path__ + "img/config.c0b1a17f.svg";